import payoutStatus from '@/domain/core/constant/payoutStatus'

export default payoutStatus